import React, { useEffect, useState, useCallback } from 'react';
import { ChevronLeft, ChevronRight, X, Star, Zap, Clock, MapPin, Users } from 'lucide-react';
import api from '../../api/client';

const MESI_FULL = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
                   'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
const GIORNI_LABEL = ['Lun','Mar','Mer','Gio','Ven','Sab','Dom'];

export default function CalendarioAllenatori() {
  const oggi = new Date();
  const [anno, setAnno]         = useState(oggi.getFullYear());
  const [mese, setMese]         = useState(oggi.getMonth() + 1);
  const [presenze, setPresenze] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [giornoSel, setGiornoSel] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get(`/dipendenti/me/calendario/${anno}/${mese}`);
      setPresenze(r.data);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [anno, mese]);

  useEffect(() => { load(); setGiornoSel(null); }, [load]);

  const navMese = (dir) => {
    let m = mese + dir, a = anno;
    if (m > 12) { m = 1; a++; }
    if (m < 1)  { m = 12; a--; }
    setMese(m); setAnno(a);
  };

  // Griglia mese
  const primoGiorno  = new Date(anno, mese - 1, 1);
  const offsetInizio = (primoGiorno.getDay() + 6) % 7;
  const giorniMese   = new Date(anno, mese, 0).getDate();
  const celle = [];
  for (let i = 0; i < offsetInizio; i++) celle.push(null);
  for (let g = 1; g <= giorniMese; g++) celle.push(g);
  while (celle.length % 7 !== 0) celle.push(null);

  const presenzePerGiorno = presenze.reduce((acc, p) => {
    const g = new Date(p.data).getDate();
    if (!acc[g]) acc[g] = [];
    acc[g].push(p);
    return acc;
  }, {});

  const presenzeGiorno = giornoSel
    ? [...(presenzePerGiorno[giornoSel] || [])].sort((a,b) => (a.ora_inizio || '').localeCompare(b.ora_inizio || ''))
    : [];

  const dataGiornoSel = giornoSel
    ? new Date(anno, mese - 1, giornoSel).toLocaleDateString('it-IT',{ weekday:'long', day:'numeric', month:'long' })
    : '';

  return (
    <div style={{ maxWidth:'900px', margin:'0 auto' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px', flexWrap:'wrap', gap:'12px' }}>
        <div>
          <h1 style={s.title}>CALENDARIO ALLENATORI</h1>
          <p style={s.sub}>Chi allena e quando — sola lettura</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <button style={s.navBtn} onClick={() => navMese(-1)}><ChevronLeft size={16}/></button>
          <span style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-xl)', fontWeight:'800', minWidth:'180px', textAlign:'center' }}>
            {MESI_FULL[mese-1].toUpperCase()} {anno}
          </span>
          <button style={s.navBtn} onClick={() => navMese(1)}><ChevronRight size={16}/></button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:'60px', color:'#555' }}>Caricamento...</div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns: giornoSel ? '1fr 300px' : '1fr', gap:'20px', alignItems:'start' }}>
          <div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'4px', marginBottom:'4px' }}>
              {GIORNI_LABEL.map(g => (
                <div key={g} style={{ textAlign:'center', fontSize: 'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', color:'#555', padding:'4px 0' }}>{g}</div>
              ))}
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:'4px' }}>
              {celle.map((giorno, i) => {
                if (!giorno) return <div key={i}/>;
                const ps     = presenzePerGiorno[giorno] || [];
                const isOggi = giorno===oggi.getDate() && mese===oggi.getMonth()+1 && anno===oggi.getFullYear();
                const isSel  = giorno === giornoSel;

                return (
                  <div key={i} onClick={() => setGiornoSel(isSel ? null : giorno)}
                    style={{ background: isSel?'#F4600C15':'var(--bg-card,#141414)',
                      border:`1px solid ${isSel?'#F4600C':isOggi?'#F4600C50':'var(--border,#1E1E1E)'}`,
                      borderRadius:'8px', padding:'8px', minHeight:'70px', cursor:'pointer', transition:'all 0.15s' }}
                    onMouseEnter={e=>{ if(!isSel) e.currentTarget.style.borderColor='#F4600C40'; }}
                    onMouseLeave={e=>{ if(!isSel) e.currentTarget.style.borderColor=isOggi?'#F4600C50':'var(--border,#1E1E1E)'; }}>
                    <div style={{ fontSize: 'var(--font-size-xs)', fontWeight:'700', color:isSel||isOggi?'#F4600C':'var(--text,#fff)', marginBottom:'4px' }}>{giorno}</div>
                    {ps.length > 0 && (
                      <div style={{ display:'flex', flexDirection:'column', gap:'2px' }}>
                        {ps.slice(0,3).map(p => {
                          const isExtra = p.tipo === 'FISSO' || p.tipo === 'SPOT';
                          return (
                            <div key={p.id} style={{ fontSize: 'var(--font-size-xs)', background: isExtra ? '#8B5CF620' : '#88888820',
                              color: isExtra ? '#8B5CF6' : '#aaa',
                              borderRadius:'3px', padding:'1px 4px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontWeight:'600' }}>
                              {p.dipendente?.cognome} {p.tipo==='FISSO' ? (p.tipo_attivita?.nome || '★') : p.ora_inizio}
                            </div>
                          );
                        })}
                        {ps.length > 3 && <div style={{ fontSize: 'var(--font-size-xs)', color:'#555' }}>+{ps.length-3}</div>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {giornoSel && (
            <div style={{ background:'var(--bg-card,#141414)', border:'1px solid #F4600C40', borderRadius:'12px', overflow:'hidden', position:'sticky', top:'20px' }}>
              <div style={{ padding:'12px 16px', background:'#F4600C15', borderBottom:'1px solid #F4600C30', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div style={{ fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-sm)', fontWeight:'800', color:'#F4600C', textTransform:'uppercase' }}>{dataGiornoSel}</div>
                <button style={{ ...s.navBtn, padding:'6px' }} onClick={() => setGiornoSel(null)}><X size={14}/></button>
              </div>
              <div style={{ padding:'12px 16px', display:'flex', flexDirection:'column', gap:'8px', maxHeight:'420px', overflowY:'auto' }}>
                {presenzeGiorno.length === 0 ? (
                  <p style={{ textAlign:'center', color:'#555', fontSize: 'var(--font-size-xs)', padding:'20px 0' }}>
                    <Users size={24} color="var(--text-dim)" style={{ marginBottom:'8px' }}/><br/>
                    Nessun allenamento in questo giorno.
                  </p>
                ) : presenzeGiorno.map(p => {
                  const isFisso = p.tipo === 'FISSO';
                  const isSpot  = p.tipo === 'SPOT';
                  return (
                    <div key={p.id} style={{ background:'var(--bg-input,#1A1A1A)', border:`1px solid ${(isFisso||isSpot)?'#8B5CF630':'#33333350'}`, borderRadius:'8px', padding:'10px 12px' }}>
                      <div style={{ fontWeight:'700', fontSize: 'var(--font-size-sm)' }}>{p.dipendente?.cognome} {p.dipendente?.nome}</div>
                      {isFisso ? (
                        <div style={{ fontSize: 'var(--font-size-xs)', color:'#8B5CF6', fontWeight:'600', marginTop:'2px', display:'flex', alignItems:'center', gap:'4px' }}>
                          <Star size={10}/> {p.tipo_attivita?.nome || 'Attività'}
                        </div>
                      ) : (
                        <div style={{ fontSize: 'var(--font-size-xs)', color: isSpot?'#8B5CF6':'#888', fontWeight:'600', marginTop:'2px', display:'flex', alignItems:'center', gap:'4px', fontFamily:'monospace' }}>
                          {isSpot ? <Zap size={10}/> : <Clock size={10}/>} {p.ora_inizio} – {p.ora_fine}
                        </div>
                      )}
                      {p.luogo && <div style={{ fontSize: 'var(--font-size-xs)', color:'#777', marginTop:'2px', display:'flex', alignItems:'center', gap:'3px' }}><MapPin size={9}/>{p.luogo}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  title:  { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', letterSpacing:'2px' },
  sub:    { color:'var(--text-muted,#888)', fontSize: 'var(--font-size-sm)', marginTop:'4px' },
  navBtn: { background:'var(--bg-input,#1A1A1A)', border:'1px solid var(--border2,#2A2A2A)', borderRadius:'8px', padding:'8px 10px', color:'var(--text,#fff)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' },
};
